const colorPalette = (elementsCount: number): Array<string> => {
  if (elementsCount === 1) {
    return ["#C62A77"];
  }
  if (elementsCount === 2) {
    return ["#C62A77", "#673490"];
  }
  if (elementsCount === 3) {
    return ["#C62A77", "#673490", "#DE6F35"];
  }
  if (elementsCount === 4) {
    return ["#C62A77", "#673490", "#DE6F35", "#4F4F4F"];
  }
  if (elementsCount === 5) {
    return ["#C62A77", "#673490", "#DE6F35", "#4F4F4F", "#775dd0"];
  }
  if (elementsCount === 6) {
    return ["#C62A77", "#673490", "#DE6F35", "#4F4F4F", "#775dd0", "#ff4560"];
  }
  if (elementsCount === 7) {
    return [
      "#C62A77",
      "#673490",
      "#DE6F35",
      "#4F4F4F",
      "#775dd0",
      "#ff4560",
      "#333333",
    ];
  }
  if (elementsCount === 8) {
    return [
      "#C62A77",
      "#673490",
      "#DE6F35",
      "#4F4F4F",
      "#775dd0",
      "#ff4560",
      "#333333",
      "#E03D8A",
    ];
  }

  if (elementsCount === 9) {
    return [
      "#C62A77",
      "#673490",
      "#DE6F35",
      "#4F4F4F",
      "#775dd0",
      "#ff4560",
      "#333333",
      "#E03D8A",
      "#6A4A96",
    ];
  }
  if (elementsCount === 10) {
    return [
      "#C62A77",
      "#673490",
      "#DE6F35",
      "#4F4F4F",
      "#775dd0",
      "#ff4560",
      "#333333",
      "#E03D8A",
      "#6A4A96",
      "#E5864D",
    ];
  }
  if (elementsCount === 11) {
    return [
      "#C62A77",
      "#673490",
      "#DE6F35",
      "#4F4F4F",
      "#775dd0",
      "#ff4560",
      "#333333",
      "#E03D8A",
      "#6A4A96",
      "#E5864D",
      "#6A6A6A",
    ];
  }
  if (elementsCount === 12) {
    return [
      "#C62A77",
      "#673490",
      "#DE6F35",
      "#4F4F4F",
      "#775dd0",
      "#ff4560",
      "#333333",
      "#E03D8A",
      "#6A4A96",
      "#E5864D",
      "#6A6A6A",
      "#977BE2",
    ];
  }
  return [
    "#C62A77",
    "#673490",
    "#DE6F35",
    "#4F4F4F",
    "#775dd0",
    "#ff4560",
    "#333333",
    "#E03D8A",
    "#6A4A96",
    "#E5864D",
    "#6A6A6A",
    "#977BE2",
  ];
};

export { colorPalette as default };
